import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/user/list',
    name: 'UserList',
    component: () => import('@/views/user/index.vue'),
    meta: {
      title: '用户列表',
      permission: 'user:list'
    }
  },
  {
    path: '/user/detail/:id',
    name: 'UserDetail',
    component: () => import('@/views/user/detail.vue'),
    meta: {
      title: '用户详情',
      hidden: true
    }
  }
]

export default routes
